type GetNavigationColumnAttributes = {
  hasSecondaryNavigation: boolean
}

export const getNavigationColumnAttributes = ({
  hasSecondaryNavigation
}: GetNavigationColumnAttributes) => {
  if (hasSecondaryNavigation) {
    return {
      navigation: {
        md: 5,
        lg: 4,
        offset: {
          md: 1,
          lg: 2
        }
      },
      navigationSecondary: {
        md: 5,
        lg: 4
      }
    }
  }

  return {
    navigation: {
      md: 8,
      lg: 4
    },
    navigationSecondary: {}
  }
}
